<template>
  <div class="container">
    <div class="row">
      <div class="text--base">
        <Milestones :content="milestonesContent" class="chapter-one__content" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import Milestones from '@/components/content/Milestones.vue';

export default {
  name: 'App1Timeline',
  components: {
    Milestones,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    milestonesContent() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'milestones') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-01.json`);
  },
};
</script>